export default __webpack_public_path__ + "7a8fa10e0bdbb562e50de4c41f2544a6.svg";